import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/common/Icon/Icon';
import PageContainer from '../../components/common/PageContainer/PageContainer';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import styles from './SysHome.module.css';

const SYS_LINKS = [
  {
    to: '/sys/logs',
    title: 'Logs',
    description: 'Logs do sistema do portal e do app.',
    icon: 'terminal',
  },
  {
    to: '/sys/payment-errors',
    title: 'Erros de pagamento',
    description: 'Falhas de cobrança e eventos de webhook para reprocessar.',
    icon: 'error',
  },
] as const;

const SysHome: React.FC = () => (
  <PageContainer className={styles.page}>
    <PageHeader
      title="Sistema"
      subtitle="Ferramentas internas de diagnóstico"
    />

    <div className={styles.links}>
      {SYS_LINKS.map((item) => (
        <Link key={item.to} to={item.to} className={styles.linkCard}>
          <span className={styles.iconWrap} aria-hidden="true">
            <Icon name={item.icon} size={22} />
          </span>
          <span className={styles.linkBody}>
            <span className={styles.linkTitle}>{item.title}</span>
            <span className={styles.linkDescription}>{item.description}</span>
          </span>
          <span className={`material-symbols-outlined ${styles.chevron}`} aria-hidden="true">
            chevron_right
          </span>
        </Link>
      ))}
    </div>
  </PageContainer>
);

export default SysHome;
